<template>
  <div>
    <label :class="labelComputedClasses" :for="id">
      <span>{{ label }}</span>
      <ips-tooltip :tooltip="tooltip">
        <ips-icon v-if="tooltip" icon="ico-help"></ips-icon>
      </ips-tooltip>
    </label>

    <div class="tag-input d-flex flex-wrap" @click="setCursor">
      <div v-for="(tag, index) in tags" :key="index" class="tag-input-tag">
        <ips-badge
          :id="tag.id"
          :icon-append="tag.removable ? 'ico-delete' : ''"
          :variant="tag.variant"
          :variant-style="tag.variantStyle"
          @append-icon-clicked.stop="removeTag(index)"
          >{{ tag.label }}</ips-badge
        >
      </div>
      <div class="flex-grow-1">
        <input
          :id="id"
          :ref="tagInputRef"
          :disabled="disabled"
          :required="required"
          :readonly="readonly"
          :placeholder="placeholder"
          :tabindex="tabindex"
          class="tag-input-text"
          type="text"
          @blur="addTag"
          @input="$emit('input', $event.target.value)"
          @keydown.enter="addTag"
          @keydown.188="addTag"
          @keydown.delete="removeLastTag"
        />
      </div>
    </div>
  </div>
</template>

<script>
import IpsIcon from '@ipscape/ips-icon';
import IpsBadge from '@ipscape/ips-badge';
import IpsTooltip from '@ipscape/ips-tooltip';
import { formFieldsMixin } from '../../../mixins/index.js';

export default {
  name: 'IpsTagInput',
  components: { IpsIcon, IpsBadge, IpsTooltip },
  mixins: [formFieldsMixin],
  props: {
    tags: {
      name: 'tags',
      type: Array,
      default: () => [],
      description: 'Tags',
      required: true,
    },
  },
  data() {
    return {
      tagsData: this.tags,
    };
  },
  computed: {
    tagInputRef() {
      return this.id + 'Ref';
    },
  },
  methods: {
    addTag(event) {
      event.preventDefault();
      const val = event.target.value.trim();
      if (val.length > 0) {
        let addedTag = { value: val, variant: 'gray', variantStyle: 'subtle', removable: true };
        this.tagsData.push(addedTag);
        event.target.value = '';
        this.$emit('added', addedTag);
        this.updatedTags();
      }
    },
    removeTag(index) {
      this.tagsData.splice(index, 1);
      this.$emit('removed', index);
      this.updatedTags();
    },
    removeLastTag(event) {
      if (event.target.value.length === 0) {
        const indexToRemove = this.tagsData.length - 1;
        if (indexToRemove >= 0 && this.tags[indexToRemove].removable) {
          this.removeTag(indexToRemove);
        }
      }
    },
    updatedTags() {
      this.$emit('updated', this.tagsData);
    },
    setCursor() {
      this.$refs[this.tagInputRef].focus();
    },
  },
};
</script>

<style lang="scss" scoped>
@import 'IpsTagInput';
</style>
